import React, { useState } from "react";
import { GoSellElements } from "@tap-payments/gosell";
import { setCookie } from "../../../global-functions/cookieFunction";
import { useSelector } from "react-redux";
import StandardBtn from "./StandardButton/StandardBtn";

const GoSellElementsDemo = (props) => {
  const {setTapId, setSaveCard, payWithValue, setButtonLoading, setTapCardDetails} = props
  const [credToken, setCredToken] = useState("");
  const appState = useSelector((state) => state);
  const callbackFunc = async (response) => {
    console.log(response);
    if (props.payWithValue == "card") {
      let res = await response.id;
      // console.log(response);
      let cardDetails = {
        first_eight_digits: response?.card?.first_eight,
      }
      console.log(response?.card , cardDetails , "cardDetails");
      setTapCardDetails(response?.card ? cardDetails : null);
      props.setTapId(response.id);
    } else {
      // console.log(response, "// console cred");
      setCredToken(response.id);
      props.setSaveCard(false);
      setCookie("cardToken", JSON.stringify(response.id));
    }
  };

  return (
    <div className="App">

      <GoSellElements
         gateway={{
          publicKey: props.status == "checkout" ? ((appState.storeInfo.tapKey != null || appState.storeInfo.tapKey != undefined) && appState.storeInfo.tapKey) : (appState.storeInfo.live ? process.env.REACT_APP_TAP_LIVE_KEY_SAVE_CARD : process.env.REACT_APP_TAP_TEST_KEY_SAVE_CARD),
          language:"en",
           supportedCurrencies: "all",
           supportedPaymentMethods: "all",
           notifications:'msg',
           callback: callbackFunc,
           labels:{
               cardNumber:"Card Number",
               expirationDate:"MM/YY",
               cvv:"CVV",
               cardHolder:"Name on Card",
               actionButton:"Pay"
           },
           style: {
               base: {
                 color: '#535353',
                 lineHeight: '18px',
                 fontFamily: 'sans-serif',
                 fontSmoothing: 'antialiased',
                 fontSize: '16px',
                 '::placeholder': {
                   color: 'rgba(0, 0, 0, 0.26)',
                   fontSize:'15px'
                 }
               },
               invalid: {
                 color: 'red',
                 iconColor: '#fa755a '
               }
           }
         }}
          />

         <p id="msg"></p>

         <StandardBtn
              requiredClass= {`btn-main payBtn`}
              label={"Pay"}
              type="text-btn"
              handleCheckout={() => GoSellElements.submit()}
              disabled={false}
            />
         {/* <button onClick={() => GoSellElements.submit()}>Submit</button> */}
    </div>
  );
};

export default GoSellElementsDemo;